import api from './api'

const suscripcionesService = {
  // ==========================================
  // CRUD SUSCRIPCIONES (SuperAdmin)
  // ==========================================

  async getAll(params = {}) {
    const response = await api.get('/suscripciones', { params })
    return response.data
  },

  async getById(id) {
    const response = await api.get(`/suscripciones/${id}`)
    return response.data
  },

  async create(data) {
    const response = await api.post('/suscripciones', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/suscripciones/${id}`, data)
    return response.data
  },

  async delete(id) {
    await api.delete(`/suscripciones/${id}`)
  },

  // ==========================================
  // CONFIGURACIÓN PROVEEDOR (SuperAdmin)
  // ==========================================

  async getConfiguracionProveedor() {
    const response = await api.get('/suscripciones/configuracion-proveedor')
    return response.data
  },

  async updateConfiguracionProveedor(data) {
    const response = await api.put('/suscripciones/configuracion-proveedor', data)
    return response.data
  },

  // ==========================================
  // MI SUSCRIPCIÓN (EmisorAdmin)
  // ==========================================

  async getMiSuscripcion() {
    const response = await api.get('/suscripciones/mi-suscripcion')
    return response.data
  },

  /**
   * Consulta el estado de la suscripción desde el Hub (vía proxy backend).
   * Retorna { mostrarBanner, mensajeBanner, colorBanner } para el SuscripcionBanner.
   */
  async getEstadoSuscripcionHub() {
    const response = await api.get('/suscripcion-status')
    const data = response.data

    const estadosConBanner = ['Por vencer', 'En gracia', 'Vencida']
    const mostrarBanner = estadosConBanner.includes(data.estado)

    let colorBanner = 'warning'
    if (data.estado === 'En gracia') colorBanner = 'warning'
    if (data.estado === 'Vencida') colorBanner = 'error'

    return {
      ...data,
      mostrarBanner,
      mensajeBanner: data.mensaje || '',
      colorBanner
    }
  },

  // ==========================================
  // ENVÍO MANUAL Y HISTORIAL
  // ==========================================

  async reactivar(id) {
    const response = await api.post(`/suscripciones/${id}/reactivar`)
    return response.data
  },

  async marcarPagado(id) {
    const response = await api.post(`/suscripciones/${id}/marcar-pagado`)
    return response.data
  },

  async enviarRecordatorio(id) {
    const response = await api.post(`/suscripciones/${id}/enviar-recordatorio`)
    return response.data
  },

  async getHistorialFacturas(id) {
    const response = await api.get(`/suscripciones/${id}/historial`)
    return response.data
  },

  async descargarMiPdf() {
    const response = await api.get('/suscripciones/mi-suscripcion/descargar-pdf', {
      responseType: 'blob'
    })
    return response.data
  },

  async previewPdf(id) {
    const response = await api.get(`/suscripciones/${id}/preview-pdf`, {
      responseType: 'blob'
    })
    return response.data
  }
}

export default suscripcionesService
